/*
 * styles.js
 * Written by: Alex Kasemir and Connor Taylor
 *
 * Exports the styled components used in the ModalWrapper component
 */

import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';

const ModalWrapperContainer = makeThemedComponent({
  component: `div`,
  themeKey: `ModalWrapper`,
  displayName: `ModalWrapperContainer`,
  defaultStyles: css`
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    flex-flow: column;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999;
  `,
});

export { ModalWrapperContainer }; // eslint-disable-line
